import { fetchAuthSession, signOut } from "aws-amplify/auth";

import { configureAmplify } from "@/shared/auth";
import { Env } from "@/shared/environment";
import { HttpClient } from "@/shared/http/HttpClient";

export async function makeAuthenticatedHttpClient() {
  // Amplify must be configured in each JS realm.
  await configureAmplify();

  return new HttpClient({
    baseUrl: new URL(Env.robotoServiceBaseUrl),
    bearerTokenVendor: async () => {
      const session = await fetchAuthSession();
      const token = session.tokens?.idToken?.toString();
      return token;
    },
    onAuthFailure: signOut,
  });
}
